import MainPage from "./static-pages/main";
import LaunchTimer from "./static-pages/launch"

function App() {
  return (
    <LaunchTimer>
        <MainPage></MainPage>
    </LaunchTimer>
   
  )
}

export default App;
